module.exports = __webpack_public_path__ + "img/558.1362ff7c.jpg";